import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button, Table, Form, InputGroup, Card, Modal } from "react-bootstrap";
import { FaPlus, FaSearch, FaShoppingCart, FaTrash } from "react-icons/fa";
import { BiRupee } from "react-icons/bi";
import { RiSave3Line } from "react-icons/ri";
import { LuPrinter } from "react-icons/lu";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";


const POS = () => {
  const quantityRef = useRef(null);
  const [billNo, setBillNo] = useState("");
  const [editablePrices, setEditablePrices] = useState({});
  const [discounts, setDiscounts] = useState("");

  const [commision, setCommision] = useState(""); // Discount in %
  const [packing, setPacking] = useState(""); // Discount in %
  const [gstAmount, setGSTAmount] = useState(""); // Discount in %
  const [cart, setCart] = useState([]);
  const [filteredCodes, setFilteredCodes] = useState([]);
  const [products, setProducts] = useState([]);
  const [fullproducts, setFullProducts] = useState([]);
  const [productCode, setProductCode] = useState("");
  const [productName, setProductName] = useState("");
  const [filteredNames, setFilteredNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [loading, setLoading] = useState(true);
  const [Loading1, setLoading1] = useState();
  const [Loading2, setLoading2] = useState();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const [agent, setAgent] = useState([]);
  const [gst, setGST] = useState({ cgst: "0", sgst: "0", packingCharge: "0.00" });

  const [customer, setCustomer] = useState([]);
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    customerName: "",
    // agent: "",
    address: "",
    place_of_supply: "",
    phonenumber: "",
    // creditlimit:"",
    gstin: "",
    state: "",
  });
  console.log(searchTerm);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  // Handle Form Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


    const payload = {
      name: formData.customerName,
      // credit_limit: formData.creditlimit,  // FIXED
      tax_number: formData.gstin,      // FIXED
      telephone: formData.phonenumber,        // FIXED
      address: formData.address,
      place_of_supply: formData.place_of_supply,
      // agent: formData.agent,
      state: formData.state
    };

    console.log("Payload:", payload);

    try {
      const response = await fetch(`${API_BASE_URL}customer_add.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data.head.code === 200) {
        alert("Customer added successfully!");
        setShow(false);
        window.location.reload();
      } else {
        alert("Failed to add customer. Error: " + data.head.msg);
      }
    } catch (error) {
      console.error("Network/API Error:", error);
      alert("Required field is empty");
    }
  };

  //   useEffect(() => {
  //   const fetchAgent = async () => {
  //     try {
  //       const response = await axios.post(`${API_BASE_URL}agent_list.php`);
  //       if (response.data.head.code === 200) {
  //         setAgent(response.data.body);
  //       } else {
  //         console.error("Error fetching agent list:", response.data.head.msg);
  //       }
  //     } catch (error) {
  //       console.error("API Error:", error);
  //     }
  //   };

  //   fetchAgent();
  // }, []); // ✅ Empty array to run only once on mount
  const handlePricePerPcsChange = (productId, countOfPcs, value) => {
    const price = parseFloat(value) || 0;

    setEditablePrices((prev) => ({
      ...prev,
      [productId]: {
        sell_rate: price,
        sell_price: price * countOfPcs, // automatically calculate
      },
    }));
  };


  useEffect(() => {
    setLoading(true);
    axios.post(`${API_BASE_URL}pos_api/pos_product_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setProducts(response.data.body.product);
          setFullProducts(response.data.body.product);
          setCustomer(response.data.body.customer);
          const cgst = response.data.body.gst.cgst;
          const sgst = response.data.body.gst.sgst;
          setGSTAmount(Number(cgst) + Number(sgst));
          // Extract and store GST details
          const gstData = response.data.body.gst;
          if (gstData) {
            setGST({
              cgst: gstData.cgst,
              sgst: gstData.sgst,
              packingCharge: gstData.packing_charge
            });
            console.log(gstData);

          }
        } else {
          console.error("Error Fetching Data", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 500); // Delay for better UI
      });
  }, []);



  // Handle product code input with dropdown suggestion
  // const handleCodeInput = (event) => {
  //   const code = event.target.value.trim().toUpperCase();
  //   setProductCode(code);

  //   if (code.length === 0) {
  //     setFilteredCodes([]);
  //     setProductName("");
  //     return;
  //   }

  //   // Filter products for dropdown suggestions
  //   const filtered = products.filter((p) => p.sno.includes(code));
  //   setFilteredCodes(filtered);

  //   // Find exact match when full code is entered
  //   const product = products.find((p) => p.sno === code);

  //   if (product) {
  //     setFilteredCodes([]); // Close dropdown

  //     // if (!product.stock || product.stock <= 0) {
  //     //   alert(`"${product.product_name}" is out of stock!`);
  //     //   setProductName(""); // Clear product name to prevent selection
  //     //   return;
  //     // }

  //     setProductName(product.product_name);
  //     addToCart(product); // ✅ Add only if in stock
  //   } else {
  //     setProductName(""); // Clear if no exact match
  //   }
  // };
  const handleCodeInput = (event) => {
    const code = event.target.value.trim().toUpperCase();
    setProductCode(code);

    if (code.length === 0) {
      setFilteredCodes([]);
      setProductName("");
      return;
    }

    const filtered = products.filter((p) => p.serial_no.includes(code));
    setFilteredCodes(filtered);

    const product = products.find((p) => p.serial_no === code);

    if (product) {
      setFilteredCodes([]);
      setProductName(product.product_name);
      // ✅ Do NOT call addToCart here
    } else {
      setProductName("");
    }
  };





  // Handle dropdown selection
  const handleDropdownSelect = (product) => {
    setFilteredCodes([]); // Close dropdown
    setFilteredNames([]);



    // Ensure product is valid
    if (!product || !product.serial_no || !product.product_name) {
      alert("Invalid product selection!");
      return;
    }

    // Strict stock check
    // if (!product.stock || product.stock <= 0) {
    //   alert(`"${product.product_name}" is out of stock!`);
    //   return;
    // }

    setProductCode(product.serial_no);
    setProductName(product.product_name);
    // addToCart(product); // ✅ Add to cart only if in stock

    // ✅ Focus quantity input
    setTimeout(() => {
      quantityRef.current?.focus();
    }, 0);
  };



  // Handle Product Name Input
  //   const handleNameInput = (event) => {
  //     const name = event.target.value.trim();
  //     setProductName(name);

  //     if (!products.length) return; // Ensure products are loaded

  //     // Find product ignoring case and trimming spaces
  //     const product = products.find((p) => p.product_name.trim().toLowerCase() === name.toLowerCase());

  //     console.log("Selected Name:", name);
  //     console.log("Matching Product:", product);

  //     if (product) {
  //         if (!product.sno) {
  //             alert("Invalid product details!");
  //             setProductCode("");
  //             setProductName("");
  //             return;
  //         }

  //         // if (!product.stock || product.stock <= 0) {
  //         //     alert(`"${product.product_name}" is out of stock!`);
  //         //     setProductCode("");
  //         //     setProductName("");
  //         //     return;
  //         // }

  //         setProductCode(product.sno);
  //         // addToCart(product);
  //     } else {
  //         setProductCode("");
  //     }
  // };
  const handleNameInput = (event) => {
    // const name = event.target.value.trim(); //  white-space not allowed
    const name = event.target.value; // white-space allowed
    setProductName(name);

    if (name.length === 0) {
      setFilteredNames([]);
      setProductCode("");
      return;
    }

    const filtered = products.filter((p) =>
      p.product_name.toLowerCase().includes(name.toLowerCase())
    );
    setFilteredNames(filtered);

    const product = products.find(
      (p) => p.product_name.toLowerCase() === name.toLowerCase()
    );

    if (product) {
      setFilteredNames([]);
      setProductCode(product.serial_no);
      // ✅ Do NOT call addToCart here
    } else {
      setProductCode("");
    }
  };



  // Add Product to Cart
  // const addToCart = (product) => {
  //   // if (product.stock === 0) {
  //   //   alert(`"${product.product_name}" is out of stock!`);
  //   //   return; // Prevent adding to cart
  //   // }

  //   setCart((prevCart) => {
  //     const existingProduct = prevCart.find((item) => item.product_id === product.product_id);
  //     if (existingProduct) {
  //       // if (existingProduct.qty + 1 > product.stock) {
  //       //   alert(`Only ${product.stock} items available in stock!`);
  //       //   return prevCart;
  //       // }
  //       return prevCart.map((item) =>
  //         item.product_id === product.product_id ? { ...item, qty: existingProduct.qty + 1 } : item
  //       );
  //     } else {
  //       return [...prevCart, { ...product, qty: 1 }];
  //     }
  //   });
  // };
  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item.product_id === product.product_id);
      const inputQty = product.qty || 1; // ✅ Use passed qty or fallback

      if (existingProduct) {
        return prevCart.map((item) =>
          item.product_id === product.product_id
            ? { ...item, qty: item.qty + inputQty } // ✅ Add input quantity
            : item
        );
      } else {
        return [...prevCart, { ...product, qty: inputQty }]; // ✅ Use input quantity
      }
    });
  };



  const handleQtyChange = (e, product) => {
    let prevQty = product.qty; // Store previous quantity
    let newQty = e.target.value.replace(/^0+/, ""); // Remove leading zeros

    if (newQty === "" || isNaN(newQty)) {
      newQty = "";
    } else {
      newQty = parseInt(newQty, 10);

      // ✅ Ensure new quantity is not less than 1
      if (newQty < 1) {
        newQty = 1;
      }

      // ✅ Handle stock limit and show alert correctly
      // if (newQty > product.stock) {
      //     alert(`Only ${product.stock} items available in stock!`);
      //     newQty = product.stock; // Reset to max stock
      // }
    }

    // ✅ Update state correctly
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === product.product_id ? { ...item, qty: newQty } : item
      )
    );
  };

  // ✅ Ensure Minimum Quantity = 1 on Blur
  const handleQtyBlur = (e, product) => {
    let newQty = parseInt(e.target.value, 10) || 1;
    if (newQty < 1) newQty = 1;

    setCart((prevCart) =>
      prevCart.map((item) =>
        item.product_id === product.product_id ? { ...item, qty: newQty } : item
      )
    );
  };
  // const calculateTotal = () => {
  //   return cart.reduce((total, item) => {
  //     return total + item.sell_price * item.qty;
  //   }, 0) || 0;
  // };
  const calculateTotal = () => {
    return (
      cart.reduce((total, item) => {
        const editedSellPrice =
          editablePrices[item.product_id]?.sell_price ?? item.sell_price;

        return total + (editedSellPrice * item.qty);
      }, 0) || 0
    );
  };
  const calculateNetTotal = () => {
    return (
      cart.reduce((total, item) => {
        const editedSellPrice =
          editablePrices[item.product_id]?.sell_rate ?? item.sell_rate;

        const itemTotal = editedSellPrice * item.qty || 0;
        const discount = discounts[item.product_id] ?? 0;
        const net = itemTotal - (itemTotal * discount / 100);

        return total + net;
      }, 0) || 0
    );
  };


  // Get CGST and SGST from the API response
  // const cgstAmount = (calculateTotal() * (parseFloat(gst.cgst) / 100));
  // const sgstAmount = (calculateTotal() * (parseFloat(gst.sgst) / 100));
  // const IgstAmount = cgstAmount + sgstAmount;
  // Convert packing charge from string to float
  const packingCharge = gst.packingCharge
    ? (parseFloat(gst.packingCharge) / 100) * calculateTotal()
    : 0;
  // Calculate Grand Total
  // const grandtotal = Math.round(calculateTotal() + cgstAmount + sgstAmount + packingCharge);

  const total = calculateNetTotal(); // ✅ call the function
  // const discountAmount = Math.round((total * discount) / 100);
  // const discountedTotal = total - discountAmount;
  // const grandtotal = Math.round(discountedTotal);
  const discountAmount = Math.round((total * discounts) / 100);
  const remainingTotal = total - discountAmount;
  const commisionAmount = Math.round((remainingTotal * commision) / 100);
  const GSTAmount = Math.round((remainingTotal * gstAmount) / 100);

  const packingAmount = Math.round((remainingTotal * packing) / 100);

  const finalTotal = remainingTotal - commisionAmount + packingAmount + GSTAmount;
  const grandtotal = Math.round(finalTotal);

  // ✅ Console Debugging
  console.log("Subtotal:", calculateTotal().toFixed(2));
  // console.log("CGST (" + gst.cgst + "%):", cgstAmount.toFixed(2));
  // console.log("SGST (" + gst.sgst + "%):", sgstAmount.toFixed(2));
  console.log("Packing Charge:", packingCharge.toFixed(2));
  console.log("Grand Total:", grandtotal);



  const removeItem = (id) => {
    setCart(cart.filter((item) => item.product_id !== id));
  };

  const handleSave = () => {
    if (!selectedCustomer) {
      alert("Please select a customer.");
      return;
    }
    setLoading1(true);
    if (!cart || cart.length === 0) {
      alert("Please select a product");
      return;
    }


    const orderData = {
      user_id: selectedCustomer.user_id,
      bill_no: billNo,
      order_date: selectedDate,
      billing_name: selectedCustomer.name,
      billing_phonenumber: selectedCustomer.telephone,
      billing_state: selectedCustomer.state,
      total: grandtotal,
      subtotal: calculateNetTotal(),
      gst_percentage: gstAmount,
      cgst: GSTAmount / 2,
      sgst: GSTAmount / 2,
      packing_charge: packingCharge,
      discount_percentage: discounts,
      discount_amount: discountAmount,
      commision_percentage: commision,
      commision_amount: commisionAmount,
      packing_percentage: packing,
      packing_amount: packingAmount,
      productdetails: cart.map(item => {
        const sellPrice =
          editablePrices[item.product_id]?.sell_rate ?? item.sell_rate;

        // const discountPercent = discounts[item.product_id] ?? 0;
        const total = sellPrice * item.qty;
        // const netTotal = total - (total * discountPercent / 100);

        return {
          product_id: item.product_id,
          product_name: item.product_name,
          rate_per: item.rate_per,
          // price_per_pcs:
          //   editablePrices[item.product_id]?.sell_rate ?? item.sell_rate,
          box_contents: item.box_contents,
          qty: item.qty,
          unit: item.unit,
          // amount_per_product: sellPrice,
          amount_per_product: editablePrices[item.product_id]?.sell_rate ?? item.sell_rate,
          total_per_product: total,
          // discount_percentage: discountPercent,
          // net_total: netTotal,
        };
      })
    };
    console.log("line 534 ",orderData);
    axios.post(`${API_BASE_URL}pos_api/pos_order.php`, orderData)

      .then(response => {
        if (response.data.head.code === 200) {
          console.log("Order Saved:", response.data);
          alert("Order saved successfully!");
          setCart([]);
          window.location.reload();
        } else {
          console.log("Error", response.data.head.msg)
        }

      })
      .catch(error => {
        console.error("Save Order Error:", error);
        alert("Failed to save order.");
      }).finally(() => {
        setLoading1(false);
      });
  };


  // const handleCustomerSelect = (e) => {
  //     const selectedId = e.target.value;
  //     const selected = customer.find(c => c.user_id === selectedId);
  //     if (selected) {
  //       setSelectedCustomer({ 
  //         user_id: selected.user_id, 
  //         name: selected.name,
  //         phonenumber:selected.telephone, 
  //         is_bill_eligible: parseFloat(selected.is_bill_eligible) 
  //       });
  //     }
  //   };
  // console.log(selectedCustomer);


  const cleanText = (text) => (text ? text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim().toLowerCase() : "");

  const filteredProducts = fullproducts.filter((product) => {
    const search = cleanText(searchTerm);
    const productName = cleanText(product.product_name);
    const categoryName = cleanText(product.category_name);
    const brand = cleanText(product.brand);

    console.log(`Checking: Brand="${brand}", Search="${search}"`);

    return (
      productName.includes(search) ||
      categoryName.includes(search) ||
      brand.includes(search)
    );
  });


  // ✅ Local quantity state
  const [quantity, setQuantity] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");


  // ✅ Ref for Quantity input
  const productCodeRef = useRef(null); // ✅ New ref


  // ✅ Handle Tab key from Product Code field
  const handleCodeKeyDown = (e) => {
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault();
      quantityRef.current?.focus();
    }
  };

  const handleQuantityKeyDown = (e) => {
    if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault();
      productCodeRef.current?.focus();
    }
  };

  /*
  const handleQuantityKeyDown = (e) => {
  if (e.key === "Tab" && !e.shiftKey) {
    e.preventDefault();

    const product = products.find((p) => p.sno === productCode);

    if (product && quantity > 0) {
      // Add to cart with qty
      // addToCart({ ...product, qty: Number(quantity) });
      addToCart({ ...product, qty: Number(quantity) }); // ✅ Pass qty into product


      // Reset for next entry
      setProductCode("");
      setProductName("");
      setQuantity("");
      setFilteredCodes([]);

      // Refocus on product code input
      productCodeRef.current?.focus();
    } else {
      alert("Invalid product or quantity");
    }
  }
};
*/
  const handleQuantityBlur = () => {
    // Perform the same logic as when tabbing on desktop
    const product = products.find((p) => p.serial_no === productCode);

    if (product && quantity > 0) {
      // Add to cart with qty
      addToCart({ ...product, qty: Number(quantity) });

      // Reset for next entry
      setProductCode("");
      setProductName("");
      setQuantity("");
      setFilteredCodes([]);

      // Refocus on product code input
      productCodeRef.current?.focus();
    } else {
      alert("Invalid product or quantity");
    }
  };

  const handleDiscountChange = (productId, value) => {
    setDiscounts(prev => ({
      ...prev,
      [productId]: value === "" ? "" : Number(value),
    }));
  };

  const [selectedDate, setSelectedDate] = useState("");

  // Convert yyyy-mm-dd to dd-mm-yyyy
  const formatToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  return (
    <Container fluid classNam e="p-3" style={{ minHeight: "100vh" }}>

      <Row>
        <Col className="border-end mt-2" style={{
          height: "95vh",
          display: "flex",
          flexDirection: "column",
        }}>
          <Row className=" mb-3 d-md-flex align-items-center">
            {/* <Col md={4} > */}
            <Col className="sml-scrn input-group mb-3" md={4}>
              {/* <InputGroup className="mb-3"> */}
              <Form.Select
                value={selectedCustomer ? selectedCustomer.user_id : ""} // ✅ Ensures dropdown resets
                onChange={(e) => {
                  const user = customer.find(c => c.user_id === e.target.value);
                  setSelectedCustomer(user || null); // ✅ Update or reset properly
                }}
              >
                <option value="">Select Customer</option>
                {Array.isArray(customer) && customer.map((c) => (
                  <option key={c.user_id} value={c.user_id}>{c.name}</option>
                ))}
              </Form.Select>
              <Button variant="primary" onClick={handleShow} style={{ marginTop: "0px" }} >
                <FaPlus />
              </Button>&nbsp;&nbsp;
              <Button className="btn btn-solid pos-back-btn" onClick={() => window.history.back()}>
                Back
              </Button>
            </Col>

            <Col className="sml-scrn" md={4}>
              <Form.Control
                type="text"
                placeholder="Address"
                value={selectedCustomer?.address || ""}
                readOnly
              />
            </Col>

            <Col md={1}>
              <Form.Control
                className="edit-sml-bill"
                type="text"
                placeholder="Bill No"
                value={billNo}
                onChange={(e) => setBillNo(e.target.value)}
              />
            </Col>

            {/* Date Input */}
            {/* &nbsp;&nbsp; */}
            <div className="date-sml-scrn">
              <Form.Control
                type="date"
                onChange={(e) => {
                  const formattedDate = formatToDDMMYYYY(e.target.value);
                  setSelectedDate(formattedDate);
                }}
                style={{ maxWidth: "200px" }}
              />
              {/* &nbsp;&nbsp;
            <Col md={1} className="d-flex gap-2">
              <Button variant="primary" onClick={handleShow} style={{ marginTop: "0px" }} >
                <FaPlus />
              </Button>&nbsp;&nbsp;
              <Button className="btn btn-solid pos-back-btn" onClick={() => window.history.back()}>
                Back
              </Button>
            </Col> */}
            </div>
            <Form.Control
              className="date-big-scrn"
              type="date"
              onChange={(e) => {
                const formattedDate = formatToDDMMYYYY(e.target.value);
                setSelectedDate(formattedDate);
              }}
              style={{ maxWidth: "200px" }}
            />
          </Row>
          {/* </InputGroup> */}


          <Row>
            <Col md={4}>
              <InputGroup className="mb-3">
                <Form.Control
                  ref={productCodeRef} // ✅ Attach ref
                  type="text"
                  placeholder="Enter Serial No"
                  value={productCode}
                  onChange={handleCodeInput}
                  onKeyDown={handleCodeKeyDown} // 👈 Listen for Tab key
                  autoComplete="off"
                />
                {Array.isArray(filteredCodes) && filteredCodes.length > 0 && (
                  <div
                    className="dropdown-menu show"
                    style={{
                      width: "100%",
                      marginTop: "50px",
                      overflowY: "scroll",
                      height: "50vh",
                    }}
                  >
                    {filteredCodes.map((product) => (
                      <div
                        key={product.product_id}
                        style={{ cursor: "pointer", color: "black" }}
                        className="dropdown-item"
                        onClick={() => handleDropdownSelect(product)}
                      >
                        {product.serial_no} - {product.product_name}
                      </div>
                    ))}
                  </div>
                )}
              </InputGroup>
            </Col>

            <Col md={4}>

              <InputGroup className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Enter Product Name"
                  value={productName}
                  onChange={handleNameInput}
                  onKeyDown={handleCodeKeyDown}
                  autoComplete="off"
                />
                {Array.isArray(filteredNames) && filteredNames.length > 0 && (
                  <div
                    className="dropdown-menu show"
                    style={{
                      width: "100%",
                      marginTop: "50px",
                      overflowY: "scroll",
                      height: "50vh",
                    }}
                  >
                    {filteredNames.map((product) => (
                      <div
                        key={product.product_id}
                        style={{ cursor: "pointer", color: "black" }}
                        className="dropdown-item"
                        onClick={() => handleDropdownSelect(product)}
                      >
                        {product.product_name} - {product.serial_no}
                      </div>
                    ))}
                  </div>
                )}
              </InputGroup>
            </Col>

            <Col md={4}>
              <InputGroup className="mb-3">
                <Form.Control
                  ref={quantityRef}
                  type="number"
                  placeholder="Enter Quantity"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  onKeyDown={handleQuantityKeyDown}
                  onBlur={handleQuantityBlur}  // Handle when focus is lost (on mobile and desktop)
                />
              </InputGroup>
            </Col>
          </Row>

          {/* Table to Display Selected Products */}
          <div style={{ flexGrow: 1, overflowY: "auto", border: "1px solid #ddd" }}>
            <Table bordered responsive>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Item</th>
                  <th style={{ textAlign: "right" }}>Sell Rate</th>
                  {/* <th style={{ textAlign: "right" }}>Price per Case</th> */}
                  <th>Qty</th>
                  <th style={{ textAlign: "right" }}>Total</th>
                  {/* <th style={{ textAlign: "right" }}>Discount (%)</th>
                  <th style={{ textAlign: "right" }}>Net Total</th> */}
                  <th>Del</th>
                </tr>
              </thead>
              <tbody>
                {/* {cart.map((item, index) => { */}
                {[...cart].reverse().map((item, index) => {
                  const pricePerCase = editablePrices[item.product_id]?.sell_rate ?? item.sell_rate;
                  const total = (pricePerCase * item.qty) || 0;
                  // const discount = discounts[item.product_id] ?? "";
                  // const netTotal = total - (total * discount / 100);

                  return (
                    <tr key={item.product_id}>
                      <td>{index + 1}</td>
                      <td>{item.product_name} - ({item.serial_no})</td>

                      <td style={{ textAlign: "right" }}>
                        <input
                          type="number"
                          step="1"
                          value={editablePrices[item.product_id]?.sell_rate ?? item.sell_rate}
                          onChange={(e) =>
                            handlePricePerPcsChange(item.product_id, item.count_of_pcs, e.target.value)
                          }
                          style={{ width: "100px", textAlign: "right" }}
                        />
                      </td>

                      {/* <td style={{ textAlign: "right" }}>
                        <BiRupee />
                        {pricePerCase}
                      </td> */}

                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <input
                            type="number"
                            value={item.qty}
                            min="1"
                            className="form-control text-center"
                            style={{ width: "60px" }}
                            onInput={(e) => handleQtyChange(e, item)}
                            onBlur={(e) => handleQtyBlur(e, item)}
                          />

                        </div>
                      </td>

                      <td style={{ textAlign: "right" }}>
                        <BiRupee />
                        {total.toFixed(2)}
                      </td>

                      {/* ✅ Discount (%) Input */}

                      {/* <td style={{ textAlign: "right" }}>
                        <input
                          type="number"
                          min="0"
                          max="100"
                          step="1"
                          value={discount === null || discount === undefined ? "" : discount}
                          onChange={(e) =>
                            handleDiscountChange(item.product_id, e.target.value === "" ? "" : Number(e.target.value))
                          }
                          style={{ width: "80px", textAlign: "right" }}
                          placeholder="%"
                        />
                      </td>

                     
                      <td style={{ textAlign: "right" }}>
                        <BiRupee />
                        {netTotal.toFixed(2)}
                      </td> */}

                      {/* Delete Button */}
                      <td>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => removeItem(item.product_id)}
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

          </div>

          <div className="bg-light p-3 border rounded d-flex justify-content-between print-btn-group">

            <>
              <div className="print-btn">
                <Button variant="dark" onClick={handleSave} style={{ height: "40px" }}>

                  {Loading1 ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <RiSave3Line /> &nbsp; Save
                    </>
                  )}
                </Button>

                &nbsp;&nbsp;
              </div>
            </>

            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Sub-Total:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{calculateNetTotal().toFixed(2)}</h6>
              </div>
              {/* <div style={{ fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>
                  <input
                    type="number"
                    placeholder="Enter Discount %"
                    value={discounts}
                    onChange={(e) => setDiscounts(Number(e.target.value))}
                    style={{
                      padding: "6px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "100%"
                    }}
                  />
                </h6>
              </div>


              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Discount Amount:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{discountAmount.toFixed(2)}</h6>
              </div> */}


              {/* Packing Input */}
              {/* <div style={{ fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>
                  <input
                    type="number"
                    placeholder="Enter packing %"
                    value={packing}
                    onChange={(e) => setPacking(Number(e.target.value))}
                    style={{
                      padding: "6px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "100%"
                    }}
                  />
                </h6>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Packing Amount:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{packingAmount.toFixed(2)}</h6>
              </div> */}


              <div style={{ fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>
                  <input
                    type="number"
                    placeholder="Enter GST %"
                    value={gstAmount}
                    onChange={(e) => setGSTAmount(Number(e.target.value))}
                    style={{
                      padding: "6px",
                      fontSize: "14px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "100%"
                    }}
                  />
                </h6>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>GST Amount:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{GSTAmount.toFixed(2)}</h6>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", width: "250px", fontWeight: "bold" }}>
                <h6 style={{ color: "black", fontWeight: "bold" }}>Grand Total:</h6>
                <h6 style={{ color: "black", fontWeight: "bold" }}><BiRupee />{grandtotal.toFixed(2)}</h6>
              </div>
            </div>

          </div>

        </Col>

        {/* <Col md={6}>
      <Row>
        <Col md={7}>
          <InputGroup className="mb-3 mt-2">
            <Form.Control
              placeholder="Type category, product, or brand name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            &nbsp;&nbsp;
            <Button variant="primary" style={{marginTop:"0px"}}>
              <FaSearch />
            </Button>
          </InputGroup>
        </Col>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        
      </Row>
      <div style={{ overflowY: "scroll", height: "90vh", overflowX: "hidden" }}>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "200px" }}
          >
            <div
              className="spinner-border text-primary"
              style={{ width: "3rem", height: "3rem" }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <Row className="g-3">
            {Array.isArray(filteredProducts) && filteredProducts.length > 0 ? (
                    filteredProducts.map((product) => (
                      <Col lg={4} md={6} key={product.product_id}>
                        <Card className="text-center border" style={{ height: "150px", backgroundColor: "#dee3d6" }}>
                          <Card.Body>
                            <Card.Title style={{ fontSize: "12px", color: "black" }}>
                              {product.product_name}
                            </Card.Title>
                            <Card.Title style={{ fontSize: "12px" }}>{product.product_code}</Card.Title>
                            <Card.Text style={{ fontSize: "11px", fontWeight: "bold" }}>
                              Price: <BiRupee style={{ fontSize: "11px" }} />
                              {product.sell_price} <br />
                              Stock:
                              <span
                                style={{
                                  backgroundColor: product.stock > 10 ? "green" : "red",
                                  color: "white",
                                  padding: "3px 8px",
                                  borderRadius: "5px",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  marginLeft: "5px",
                                  display: "inline-block",
                                }}
                              >
                                {product.stock}
                              </span>
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))
                  ) : (
                    <p style={{ textAlign: "center", fontWeight: "bold" }}>No products found</p>
                  )}

            </Row>
          </>
        )}
      </div>


    </Col> */}
      </Row>
      {/* -------------Customer Add Modal  Start --------------- */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {/* agent Name */}
            {/* <Form.Group className="mb-3">
              <Form.Label>Agent Name</Form.Label>
              <select
                className="form-control"
                name="agent"
                value={customer.agent}
                onChange={handleChange}
                required
              >
                <option value="">Select Agent</option>
                {agent.map((agent) => (
                  <option key={agent.agent_name} value={agent.agent_name}>
                    {agent.agent_name}
                  </option>
                ))}
              </select>
            </Form.Group> */}

            {/* Customer Name */}
            <Form.Group className="mb-3">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                type="text"
                name="customerName"
                value={formData.customerName}
                onChange={handleChange}
                placeholder="Enter Customer Name"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="text"
                name="phonenumber"
                value={formData.phonenumber}
                onChange={handleChange}
                placeholder="Enter Phone Number"
                required
                maxLength={10}
              />
            </Form.Group>



            {/* Address */}
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter Address"
                rows={3}

              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter State"

              />
            </Form.Group>


            {/* GSTIN/UIN */}
            <Form.Group className="mb-3">
              <Form.Label>GSTIN/UIN</Form.Label>
              <Form.Control
                type="text"
                name="gstin"
                value={formData.gstin}
                onChange={handleChange}
                placeholder="Enter GSTIN/UIN"
                maxLength={15}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Place of Supply</Form.Label>
              <Form.Control
                type="text"
                name="place_of_supply"
                value={formData.place_of_supply}
                onChange={handleChange}
                placeholder="Enter Place of Supply"
              // rows={3}

              />
            </Form.Group>

            {/* Submit Button */}
            <Button variant="success" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {/* -------------Customer Add Modal  End --------------- */}
    </Container>
  );
};

export default POS;
